export const GET_LOOSENESS_DIAGNOSTIC = "GET_LOOSENESS_DIAGNOSTIC";
export const GET_LOOSENESS_DIAGNOSTIC_SUCCESS = "GET_LOOSENESS_DIAGNOSTIC_SUCCESS";
export const GET_LOOSENESS_DIAGNOSTIC_ERROR = "GET_LOOSENESS_DIAGNOSTIC_ERROR";
export const SHOW_CONCERN_FREQUENCIES = "SHOW_CONCERN_FREQUENCIES ";
export const HIDE_CONCERN_FREQUENCIES = "HIDE_CONCERN_FREQUENCIES ";
